var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"box-size"},[_c('tab-component',[_c('wildcard-presenter',{attrs:{"data":_vm.localData,"count":"3"}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }